import React, { createContext, useContext, useState } from 'react';

const BreadStorageContext = createContext();

export const BreadStorageProvider = ({ children }) => {
  const [bread, setBreadState] = useState(() => {
    return JSON.parse(
      localStorage.getItem("selectBreadcrumbs") || "{}"
    );
  });

  const setBread = (newValue) => {
    // localStorage.setItem('selectBreadcrumbs', newValue);
    setBreadState(newValue);
  };

  return (
    <BreadStorageContext.Provider value={{ bread, setBread }}>
      {children}
    </BreadStorageContext.Provider>
  );
};

export const useBreadStorageContext = () => {
  const context = useContext(BreadStorageContext);
  if (!context) {
    throw new Error('useBreadStorageContext 必須在 BreadStorageProvider 中使用');
  }
  return context;
};
